import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Raza/getDeleteSeleccion`, method: 'POST', body: {list}, token: token})
}
